import DateFormatingService from "services/DateFormatingService";

export const formatDates = () => {
  const dates = document.querySelectorAll(".js-date");

  [...dates].forEach((d) => {
    const date = d;
    const { timestamp } = date.dataset;

    if (timestamp) {
      const timestampInMiliseconds = timestamp * 1000;
      date.textContent = DateFormatingService.formatToTimeAndDate(
        timestampInMiliseconds
      ); // eslint-disable-line no-param-reassign, max-len
    }
  });
};

formatDates();
